module.exports = __webpack_public_path__ + "img/card.77dcc0d9.png";